import { useState, useEffect } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';
const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const linkedinService = {
  _url: `${process.env.REACT_APP_LEAD_API_URL}/linkedin`,
  _listurl: `${process.env.REACT_APP_LEAD_API_URL}/sublist`,
  _enrichmentUrl: `${process.env.REACT_APP_LEAD_API_URL}/enrichment`,
  _activity_url: `${process.env.REACT_APP_LEAD_API_URL}/activity`,

  GetAllLinkedinData(searchQuery, fetch) {
    const [linkedin_scrapeds, setLinkedinScrapeds] = useState({
      linkedin_scrapeds: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getAllLinkedinData(searchQuery))
        .then(res => {
          setLinkedinScrapeds(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [JSON.stringify(searchQuery), fetch]);
    return {
      linkedin_loading: status === STATUS.LOADING,
      linkedin_error: status === STATUS.ERROR,
      linkedin_data: linkedin_scrapeds?.data,
    };
  },

  GetAlluserLeads(searchQuery, fetch) {
    const [leads, setLeads] = useState({
      leads: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getUserLeads(searchQuery))
        .then(res => {
          setLeads(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [JSON.stringify(searchQuery), fetch]);

    return {
      leads_loading: status === STATUS.LOADING,
      leads_error: status === STATUS.ERROR,
      leads_data: leads,
    };
  },

  GetAllUserLists(searchQuery, fetch) {
    const [lists, setLists] = useState({
      lists: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getLists(searchQuery))
        .then(res => {
          setLists(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [JSON.stringify(searchQuery), fetch]);

    return {
      lists_loading: status === STATUS.LOADING,
      lists_error: status === STATUS.ERROR,
      lists_data: lists,
    };
  },

  GetAllActivityLogs(searchQuery, fetch) {
    const [activityLogs, setActivityLogs] = useState({
      data: [],
      totalItems: 0,
    });

    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);

    useEffect(() => {
      setStatus(STATUS.LOADING);

      cancellablePromise(this.getActivityLogs(searchQuery))
        .then(res => {
          setActivityLogs(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [JSON.stringify(searchQuery), fetch]);

    return {
      activity_logs_loading: status === STATUS.LOADING,
      activity_logs_error: status === STATUS.ERROR,
      activity_logs_data: activityLogs,
    };
  },

  async getAllLinkedinData({
    page = 1,
    itemsPerPage = 10,
    searchText = '',
    getAll = false,
    startDate = '',
    endDate = '',
  }) {
    let res = await Fetch.get(
      `${this._url}/get-all?page=${page}&itemsPerPage=${itemsPerPage}&searchText=${searchText}&getAll=${getAll}&startDate=${startDate}&endDate=${endDate}`,
    );
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something Went Wrong');
  },

  async getUserLeads({
    page = 1,
    itemsPerPage = 10,
    searchText = '',
    getAll = false,
    startDate = '',
    endDate = '',
    status = [],
    contactedStatus = 'ALL',
    source = [],
    campaigns = [],
    tagsFilter = [],
    dateCreatedFilter = '',
    listsFilter = [],
    companyName = '',
    jobTitle = '',
    language = '',
    location = '',
    industry = '',
    headline = '',
    emailExists = 'ALL',
    linkedinProfileExists = 'ALL',
    openToWork = 'ALL',
    isHiring = 'ALL',
  }) {
    const statusParam =
      Array.isArray(status) && status.length > 0 ? `&status=${encodeURIComponent(status.join(','))}` : '';
    const contactedStatusParam = contactedStatus ? `&contactedStatus=${encodeURIComponent(contactedStatus)}` : '';
    const sourceArray = Array.isArray(source) ? source : source ? [source] : [];
    const sourceParam = sourceArray.length > 0 ? `&source=${encodeURIComponent(sourceArray.join(','))}` : '';
    const campaignsArray = Array.isArray(campaigns) ? campaigns : campaigns ? [campaigns] : [];
    const campaignsParam =
      campaignsArray.length > 0 ? `&campaigns=${encodeURIComponent(campaignsArray.join(','))}` : '';
    const tagsArray = Array.isArray(tagsFilter) ? tagsFilter : tagsFilter ? [tagsFilter] : [];
    const tagsParam = tagsArray.length > 0 ? `&tags=${encodeURIComponent(tagsArray.join(','))}` : '';
    const listsArray = Array.isArray(listsFilter) ? listsFilter : listsFilter ? [listsFilter] : [];
    const listsParam = listsArray.length > 0 ? `&lists=${encodeURIComponent(listsArray.join(','))}` : '';
    const dateCreatedParam = dateCreatedFilter ? `&date_created=${encodeURIComponent(dateCreatedFilter)}` : '';
    const companyNameParam = companyName ? `&company_name=${encodeURIComponent(companyName)}` : '';
    const jobTitleParam = jobTitle ? `&job_title=${encodeURIComponent(jobTitle)}` : '';
    const languageParam = language ? `&language=${encodeURIComponent(language)}` : '';
    const locationParam = location ? `&location=${encodeURIComponent(location)}` : '';
    const industryParam = industry ? `&industry=${encodeURIComponent(industry)}` : '';
    const headlineParam = headline ? `&headline=${encodeURIComponent(headline)}` : '';

    const emailExistsParam =
      emailExists === 'EXISTS'
        ? `&email_exists=true`
        : emailExists === 'NOT_EXISTS'
          ? `&email_exists=false`
          : '';

    const linkedinProfileExistsParam =
      linkedinProfileExists === 'EXISTS'
        ? `&linkedin_url_exists=true`
        : linkedinProfileExists === 'NOT_EXISTS'
          ? `&linkedin_url_exists=false`
          : '';

    const openToWorkParam =
      openToWork === 'YES' ? `&open_to_work=true` : openToWork === 'NO' ? `&open_to_work=false` : '';

    const isHiringParam = isHiring === 'YES' ? `&is_hiring=true` : isHiring === 'NO' ? `&is_hiring=false` : '';

    let res = await Fetch.get(
      `${this._url}/get-user-leads?page=${page}&itemsPerPage=${itemsPerPage}&searchText=${searchText}&getAll=${getAll}&startDate=${startDate}&endDate=${endDate}${statusParam}${contactedStatusParam}${sourceParam}${campaignsParam}${tagsParam}${listsParam}${dateCreatedParam}${companyNameParam}${jobTitleParam}${languageParam}${locationParam}${industryParam}${headlineParam}${emailExistsParam}${linkedinProfileExistsParam}${openToWorkParam}${isHiringParam}`,
    );
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something Went Wrong');
  },

  async linkedinLogin(payload) {
    let res = await Fetch.post(`${this._url}/login`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async linkedinScraping(payload) {
    let res = await Fetch.post(`${this._url}/scraping`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async CreateTag(payload) {
    let res = await Fetch.post(`${this._url}/create-tag`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async UpdateTag(payload) {

    let res = await Fetch.put(`${this._url}/update/${payload.id}`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async DeleteTag(id) {
    let res = await Fetch.delete(`${this._url}/delete/${id}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async GetTagRelations(id) {
    let res = await Fetch.get(`${this._url}/get-tag-relations/${id}`)
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  }
  ,
  async deleteLinkedinTask(id) {
    let res = await Fetch.delete(`${this._url}/delete-task/${id}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getTags() {
    let res = await Fetch.get(`${this._url}/get-all-tags`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async createLinkedinProfile(payload) {
    let res = await Fetch.post(`${this._url}/create-profile`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async createList(payload) {
    let res = await Fetch.post(`${this._listurl}/create`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async confirmLinkedinLogin(payload) {
    let res = await Fetch.post(`${this._url}/confirm-login`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getLists({ page = 1, itemsPerPage = 10, searchText = '', getAll = false, startDate = '', endDate = '', leadModule = '' }) {
    let res = await Fetch.get(
      `${this._listurl}/get-all?page=${page}&itemsPerPage=${itemsPerPage}&searchText=${searchText}&getAll=${getAll}&startDate=${startDate}&endDate=${endDate}&leadModule=${leadModule}`,
    );
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something Went Wrong');
  },

  async getLeadsCount(payload) {
    let res = await Fetch.post(`${this._listurl}/count-by-filters`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  GetAllUserProfileData(searchQuery, fetch) {
    const [profileData, setProfileData] = useState({
      profileData: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getAllUserProfileData(searchQuery))
        .then(res => {
          setProfileData(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [JSON.stringify(searchQuery), fetch]);
    return {
      userProfile_loading: status === STATUS.LOADING,
      userProfile_error: status === STATUS.ERROR,
      userProfile_data: profileData?.data,
    };
  },

  async getAllUserProfileData({ status = 'all' }) {
    let res = await Fetch.get(`${this._url}/get-profiles?status=${status}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something Went Wrong');
  },

  GetAllSubListLeads(searchQuery, fetch) {
    const [leads, setLeads] = useState({
      leads: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getAllSublistLeads(searchQuery))
        .then(res => {
          setLeads(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [JSON.stringify(searchQuery), fetch]);

    return {
      leads_loading: status === STATUS.LOADING,
      leads_error: status === STATUS.ERROR,
      leads_data: leads,
    };
  },

  async getAllSublistLeads({
    page = 1,
    itemsPerPage = 10,
    searchText = '',
    getAll = false,
    id = '',
    status = [],
    contactedStatus = 'ALL',
    source = [],
    campaigns = [],
    tagsFilter = [],
    listsFilter = [],
    dateCreatedFilter = '',
    jobTitle = '',
    companyName = '',
    language = '',
    location = '',
    industry = '',
    headline = '',
    emailExists = 'ALL',
    linkedinProfileExists = 'ALL',
    openToWork = 'ALL',
    isHiring = 'ALL',
  }) {
    const statusParam =
      Array.isArray(status) && status.length > 0 ? `&status=${encodeURIComponent(status.join(','))}` : '';
    const contactedStatusParam = contactedStatus ? `&contactedStatus=${encodeURIComponent(contactedStatus)}` : '';
    const sourceArray = Array.isArray(source) ? source : source ? [source] : [];
    const sourceParam = sourceArray.length > 0 ? `&source=${encodeURIComponent(sourceArray.join(','))}` : '';
    const campaignsArray = Array.isArray(campaigns) ? campaigns : campaigns ? [campaigns] : [];
    const campaignsParam =
      campaignsArray.length > 0 ? `&campaigns=${encodeURIComponent(campaignsArray.join(','))}` : '';
    const tagsArray = Array.isArray(tagsFilter) ? tagsFilter : tagsFilter ? [tagsFilter] : [];
    const tagsParam = tagsArray.length > 0 ? `&tags=${encodeURIComponent(tagsArray.join(','))}` : '';
    const listsArray = Array.isArray(listsFilter) ? listsFilter : listsFilter ? [listsFilter] : [];
    const listsParam = listsArray.length > 0 ? `&lists=${encodeURIComponent(listsArray.join(','))}` : '';
    const dateCreatedParam = dateCreatedFilter ? `&date_created=${encodeURIComponent(dateCreatedFilter)}` : '';
    const companyNameParam = companyName ? `&company_name=${encodeURIComponent(companyName)}` : '';
    const jobTitleParam = jobTitle ? `&job_title=${encodeURIComponent(jobTitle)}` : '';
    const languageParam = language ? `&language=${encodeURIComponent(language)}` : '';
    const locationParam = location ? `&location=${encodeURIComponent(location)}` : '';
    const industryParam = industry ? `&industry=${encodeURIComponent(industry)}` : '';
    const headlineParam = headline ? `&headline=${encodeURIComponent(headline)}` : '';

    const emailExistsParam =
      emailExists === 'EXISTS'
        ? `&email_exists=true`
        : emailExists === 'NOT_EXISTS'
          ? `&email_exists=false`
          : '';

    const linkedinProfileExistsParam =
      linkedinProfileExists === 'EXISTS'
        ? `&linkedin_url_exists=true`
        : linkedinProfileExists === 'NOT_EXISTS'
          ? `&linkedin_url_exists=false`
          : '';

    const openToWorkParam =
      openToWork === 'YES' ? `&open_to_work=true` : openToWork === 'NO' ? `&open_to_work=false` : '';

    const isHiringParam = isHiring === 'YES' ? `&is_hiring=true` : isHiring === 'NO' ? `&is_hiring=false` : '';

    let res = await Fetch.get(
      `${this._listurl}/get-sub-list-records/${id}?page=${page}&itemsPerPage=${itemsPerPage}&searchText=${searchText}&getAll=${getAll}${statusParam}${contactedStatusParam}${sourceParam}${campaignsParam}${tagsParam}${listsParam}${dateCreatedParam}${companyNameParam}${jobTitleParam}${languageParam}${locationParam}${industryParam}${headlineParam}${emailExistsParam}${linkedinProfileExistsParam}${openToWorkParam}${isHiringParam}`,
    );
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something Went Wrong');
  },

  async downloadList({ id = '' }) {
    let res = await Fetch.get(`${this._listurl}/download-list/${id}`);
    if (res.status >= 200 && res.status < 300) {
      const blob = await res.blob();
      const contentDisposition = res.headers.get('Content-Disposition');
      let filename = `list_${id}.csv`;
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
        }
      }
      return { blob, filename };
    }
    const errorText = await res.text();
    let message = 'Something Went Wrong';
    try {
      const errorJson = JSON.parse(errorText);
      message = errorJson.message || message;
    } catch (e) {
      void e;
    }
    throw new Error(message);
  },

  async emailEnrichment(payload) {
    let res = await Fetch.post(`${this._enrichmentUrl}/emails`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getAllCampaigns() {
    let res = await Fetch.get(`${this._url}/get-all-campaigns`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getAllLists() {
    let res = await Fetch.get(`${this._url}/get-all-lists`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async deleteLinkedinProfile(id) {
    let res = await Fetch.delete(`${this._url}/delete-profile/${id}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async updateListName(payload) {
    let res = await Fetch.patch(`${this._listurl}/update/${payload.id}`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async deleteList(id) {
    let res = await Fetch.delete(`${this._listurl}/delete/${id}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async addLeadstoSublist(payload) {
    let res = await Fetch.post(`${this._listurl}/add-leads-to-list`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async deleteUserLead(id) {
    let res = await Fetch.delete(`${this._listurl}/delete-user-lead/${id}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async getActivityLogs({ id, page = 1, itemsPerPage = 10, getAll = false }) {
    let res = await Fetch.get(`${this._activity_url}/${id}?page=${page}&itemsPerPage=${itemsPerPage}&getAll=${getAll}`);

    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }

    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async singleLeadData(id) {
    let res = await Fetch.get(`${this._listurl}/preview-single-lead/${id}`);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },


  async getSublistUserLeadsPreview(payload) {
    let res = await Fetch.post(`${this._listurl}/preview-sublist-leads`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async removeLeadFromSublist(payload) {
    let res = await Fetch.post(`${this._listurl}/remove-lead-from-list`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async updateList(payload) {
    let res = await Fetch.patch(`${this._listurl}/update-list/${payload.id}`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },
  async resyncSublist(payload) {
    let res = await Fetch.post(`${this._listurl}/resync/${payload.id}`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

  async addResyncLeadsToCampaign(payload) {
    let res = await Fetch.post(`${this._listurl}/add-resync-leads-to-campaign`, payload);
    if (res.status >= 200 && res.status < 300) {
      res = await res.json();
      return res;
    }
    const { message } = await res.json();
    throw new Error(message ?? 'Something went wrong');
  },

};

export default linkedinService;
